import React from 'react';

function CategoryButton({ category, isActive, onClick }) {
  const { label, icon } = category;

  const renderIcon = () => {

    if (React.isValidElement(icon)) return icon;

    return <img src={icon} alt={label} className="category-icon" />;
  };

  return (
    <button
      className={`category-item ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      {renderIcon()}
      {label}
    </button>
  );
}

export default CategoryButton;